import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import { resources as CyclicExams } from "./CyclicExams";
import { resources as SessionExams } from "./Exams";
import { resources as Sessions } from "./Sessions";
import { resources as AcademicYears } from "./AcademicYears";
import { resources as Semesters } from "./Semesters";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <EventRepeatIcon />,
  name: "Академични години",
  title: "Академични години",
  subMenu: [AcademicYears, Semesters, Sessions, SessionExams, CyclicExams],
};
